/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdOverview } from './AdOverview';
import {
    AdOverviewFromJSON,
    AdOverviewFromJSONTyped,
    AdOverviewToJSON,
    AdOverviewToJSONTyped,
} from './AdOverview';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdSetOverview
 */
export interface AdSetOverview {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    cpa?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    cpm?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    cpc?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    pnoGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    roasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    roasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    poasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    poasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    conversionRateNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    conversionRateGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    profitNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    profitGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    profitPercentNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    profitPercentGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    unverifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    verifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    ordersGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdSetOverview
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdSetOverview
     */
    impressions?: number;
    /**
     * 
     * @type {string}
     * @memberof AdSetOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdSetOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdSetOverview
     */
    statusName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdSetOverview
     */
    status?: string;
    /**
     * 
     * @type {Array<AdOverview>}
     * @memberof AdSetOverview
     */
    ads?: Array<AdOverview>;
}

/**
 * Check if a given object implements the AdSetOverview interface.
 */
export function instanceOfAdSetOverview(value: object): value is AdSetOverview {
    return true;
}

export function AdSetOverviewFromJSON(json: any): AdSetOverview {
    return AdSetOverviewFromJSONTyped(json, false);
}

export function AdSetOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdSetOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'cpa': json['cpa'] == null ? undefined : MoneyOutputFromJSON(json['cpa']),
        'cpm': json['cpm'] == null ? undefined : MoneyOutputFromJSON(json['cpm']),
        'cpc': json['cpc'] == null ? undefined : MoneyOutputFromJSON(json['cpc']),
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'roasNet': json['roasNet'] == null ? undefined : json['roasNet'],
        'roasGross': json['roasGross'] == null ? undefined : json['roasGross'],
        'poasNet': json['poasNet'] == null ? undefined : json['poasNet'],
        'poasGross': json['poasGross'] == null ? undefined : json['poasGross'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'conversionRateNet': json['conversionRateNet'] == null ? undefined : json['conversionRateNet'],
        'conversionRateGross': json['conversionRateGross'] == null ? undefined : json['conversionRateGross'],
        'profitNet': json['profitNet'] == null ? undefined : MoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] == null ? undefined : MoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] == null ? undefined : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] == null ? undefined : json['profitPercentGross'],
        'unverifiedLeads': json['unverifiedLeads'] == null ? undefined : json['unverifiedLeads'],
        'verifiedLeads': json['verifiedLeads'] == null ? undefined : json['verifiedLeads'],
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'status': json['status'] == null ? undefined : json['status'],
        'ads': json['ads'] == null ? undefined : ((json['ads'] as Array<any>).map(AdOverviewFromJSON)),
    };
}

export function AdSetOverviewToJSON(json: any): AdSetOverview {
    return AdSetOverviewToJSONTyped(json, false);
}

export function AdSetOverviewToJSONTyped(value?: AdSetOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cpa': MoneyOutputToJSON(value['cpa']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'cpc': MoneyOutputToJSON(value['cpc']),
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'roasNet': value['roasNet'],
        'roasGross': value['roasGross'],
        'poasNet': value['poasNet'],
        'poasGross': value['poasGross'],
        'ctr': value['ctr'],
        'conversionRateNet': value['conversionRateNet'],
        'conversionRateGross': value['conversionRateGross'],
        'profitNet': MoneyOutputToJSON(value['profitNet']),
        'profitGross': MoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'unverifiedLeads': value['unverifiedLeads'],
        'verifiedLeads': value['verifiedLeads'],
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'statusName': value['statusName'],
        'status': value['status'],
        'ads': value['ads'] == null ? undefined : ((value['ads'] as Array<any>).map(AdOverviewToJSON)),
    };
}

